import React, { useState, useEffect, useRef } from 'react';
import { withFirebase } from '../Firebase';
import './DashboardNav.css';

const DashboardNav = ({ authUser, firebase }) => {
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const profileDropdownRef = useRef(null);

  const handleProfileClick = () => {
    setShowProfileMenu(!showProfileMenu);
  };

  const handleSignOut = () => {
    firebase.doSignOut();
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileDropdownRef.current && !profileDropdownRef.current.contains(event.target)) {
        setShowProfileMenu(false);
      }
    };

    if (showProfileMenu) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showProfileMenu]);

  return (
    <header className="dashboard-header">
      <div className="header-content">
        <h1 className="header-title">Douglas & McCartney</h1>
        <div className="header-actions">
          <div className="header-notifications">
            <button className="notification-button" title="Notifications">
              <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
              </svg>
              <span className="notification-badge">3</span>
            </button>
          </div>
          <div className="profile-dropdown-container" ref={profileDropdownRef}>
            <button onClick={handleProfileClick} className="user-info user-info-button">
              <div className="user-details">
                <span className="user-name">
                  {authUser.displayName || authUser.username || (authUser.email ? authUser.email.split('@')[0] : 'User')}
                </span>
                <span className="user-email">{authUser.email || ''}</span>
              </div>
              <div className="user-avatar">
                {(authUser.displayName || authUser.username || authUser.email || 'U').charAt(0).toUpperCase()}
              </div>
            </button>
            {showProfileMenu && (
              <div className="profile-dropdown-menu">
                <a href="/dashboard" className="profile-menu-item">
                  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                  </svg>
                  <span>Dashboard</span>
                </a>
                <a href="/account" className="profile-menu-item">
                  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                  <span>Profile</span>
                </a>
                <a href="/password-change" className="profile-menu-item">
                  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
                  </svg>
                  <span>Change Password</span>
                </a>
                <button onClick={handleSignOut} className="profile-menu-item">
                  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                  </svg>
                  <span>Sign Out</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default withFirebase(DashboardNav);

